import { FC } from 'react';

import Checkbox, { InputCheckboxProps } from '../checkbox/Checkbox';

const Radio: FC<InputCheckboxProps> = props => <Checkbox type="radio" {...props} />;

export default Radio;
